import Chip from "../index";

export default function BankStatement({ value, ...props }) {
  const items = {
    YES: {
      color: "success",
    },
    NO: {
      color: "warning",
    },
  };

  const item = items[value] || {
    color: "default",
  };

  return (
    <Chip color={item.color} tooltip={item.tooltip} value={value} {...props} />
  );
}
